import React from "react";
import { Icon } from "../";
import ReactTooltip from "react-tooltip";
import { prefixImgPath } from "../../_helpers";

export function RelatedArticleResultItem({ article, onSelect, isHighlighted }) {
  //determine image field
  //extract properties
  //display
  const handleSelect = () => {
    if (onSelect) onSelect(article);
  };

  // console.log('Article: ', article);

  const isWIP = article.is_wip;
  const isDraft = article.is_draft;
  const isPrivate = article.state === "private";
  const tipID = `chronos-article-result-${article.id}`;

  const imgPath = article.crest
    ? // ? `https://www.worldanvil.com${article.crest}`
      prefixImgPath(article.crest)
    : article.flag
    ? // ? `https://www.worldanvil.com${article.flag}`
      prefixImgPath(article.flag)
    : article.cover
    ? // ? `https://www.worldanvil.com${article.cover}`
      prefixImgPath(article.cover)
    : "https://www.worldanvil.com/images/placeholder-cyan.jpg";

  const classNames = ["chronos-article-picker-result-item"];
  // if (isHighlighted) classNames.push('chronos-highlighted-option');

  return (
    <div className={classNames.join(" ")} onClick={handleSelect}>
      <div className="chronos-article-picker-result-item-image">
        <img src={imgPath} alt={article.title} />
      </div>
      <div className="chronos-article-picker-result-item-details">
        <h3 className="article-result-title">
          {article.title}
          <small className="article-result-flags">
            {isPrivate && (
              <Icon
                icon="far fa-lock fa-fw"
                data-tip="Private"
                data-for={tipID}
              />
            )}
            {!isPrivate && (
              <Icon
                icon="far fa-lock-open fa-fw"
                data-tip="Public"
                data-for={tipID}
              />
            )}
            {isDraft && (
              <Icon
                icon="far fa-drafting-compass fa-fw"
                data-tip="Draft"
                data-for={tipID}
              />
            )}
            {!isDraft && (
              <Icon
                icon="far fa-star fa-fw"
                data-tip="Published"
                data-for={tipID}
              />
            )}
            {isWIP && (
              <Icon icon="far fa-cog fa-fw" data-tip="WIP" data-for={tipID} />
            )}
            {!isWIP && (
              <Icon
                icon="far fa-check fa-fw"
                data-tip="Done!"
                data-for={tipID}
              />
            )}
          </small>
        </h3>
        <h5 className="article-result-type">{article.template}</h5>
        {article && article.tags && article.tags.length > 0 && (
          <div className="article-result-tags">
            <Icon icon="far fa-tag fa-fw" data-tip="Tags" data-for={tipID} />
            <span
              data-tip={`Tags: <br />${article.tags.split(",").join(", ")}`}
              data-place="left"
              data-html
              data-for={tipID}
            >
              {article.tags.split(",").join(", ")}
            </span>
          </div>
        )}

        <div className="article-result-options">
          <a
            target="_blank"
            href={article.url}
            data-tip="Opens in New Tab"
            data-for={tipID}
          >
            <Icon icon="far fa-eye fa-fw" />
            &nbsp;View
          </a>
        </div>
        <ReactTooltip id={tipID} effect="solid" />
      </div>
    </div>
  );
}
